<template>
  <div class="d-flex justify-center pa-6">
    <EventDeletion />
  </div>
</template>
<script>
import EventDeletion from './EventDeletion.vue'
export default {
  components: { EventDeletion },
}
</script>
